export const STUDY_REVISION = 'solid-door-f1';
export const asset = (file) => `/deliverables/${file}?rev=${STUDY_REVISION}`;